import { canShareFile } from 'App/dashboards/_utils/canShareFile'
import { downloadBlob } from 'App/dashboards/_utils/downloadBlob'

export const saveBlob = (blob: Blob, filename: string) => {
  const file = new File([blob], filename, { type: blob.type })

  if (!canShareFile(file)) {
    downloadBlob(blob, filename)

    return
  }

  navigator.share({ files: [file] }).catch((error: unknown) => {
    // Dismissing the share sheet rejects with an AbortError
    if (error instanceof DOMException && error.name === 'AbortError') return

    downloadBlob(blob, filename)
  })
}
